import { useGatewayConfigs } from './GatewayConfigs';

/**
 * Hook that returns whether AI features are enabled for the current tenant.
 * This is the source of truth for determining if AI features should be shown in the UI.
 */
export function useIsAiEnabled(): boolean {
  const gatewayConfigs = useGatewayConfigs();
  return gatewayConfigs.aiGatewayEnabled;
}
